import { render, staticRenderFns } from "./vipList.vue?vue&type=template&id=28c02397&scoped=true"
import script from "./vipList.vue?vue&type=script&lang=js"
export * from "./vipList.vue?vue&type=script&lang=js"
import style0 from "./vipList.vue?vue&type=style&index=0&id=28c02397&prod&scoped=true&lang=scss"
import style1 from "./vipList.vue?vue&type=style&index=1&id=28c02397&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c02397",
  null
  
)

export default component.exports